/* NZ/AU 独立店铺手动选择；仅原生链接导航，不执行自动定位或市场提交。 */
(() => {
  const KEY = 'rewahard-store-preference';
  const PARAM = 'rewa_store_choice';
  const VALID = (country) => country === 'NZ' || country === 'AU';
  const DURATION = 30 * 24 * 60 * 60 * 1000;
  let arrivalProcessed = false;
  let visitChoice;

  const remember = (country) => {
    if (!VALID(country)) return;
    visitChoice = { country, until: Date.now() + DURATION };
    try {
      window.localStorage.setItem(KEY, JSON.stringify(visitChoice));
    } catch {
      // 存储不可用时仍保留本次页面的明确选择，不阻断链接导航。
    }
  };

  const hasChosenStore = (country) => {
    if (!VALID(country)) return false;
    if (!arrivalProcessed) {
      arrivalProcessed = true;
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.get(PARAM) === country) {
          remember(country);
          url.searchParams.delete(PARAM);
          window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        }
      } catch {
        // URL/history 降级不能影响正常浏览或已读到的选择。
      }
    }
    let choice = visitChoice;
    if (!choice) {
      try {
        choice = JSON.parse(window.localStorage.getItem(KEY));
      } catch {
        return false;
      }
    }
    return choice?.country === country && Number.isFinite(choice.until) && choice.until > Date.now();
  };

  // 地区弹窗与顶部入口共用此选择状态；关闭顶部开关不取消明确的留站意图。
  window.RewaStorePreference = { remember, hasChosenStore };

  class StoreSelector extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      if (!this.details || !this.trigger) return;
      hasChosenStore(this.dataset.country);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape' || !this.details.open) return;
          event.preventDefault();
          event.stopPropagation();
          this.close(true);
        },
        options
      );
      this.querySelector('[data-store-close]').addEventListener('click', () => this.close(true), options);
      document.addEventListener(
        'click',
        (event) => {
          if (!this.contains(event.target)) this.close();
        },
        options
      );
      // Safari/iOS 点链接时焦点落到 body（relatedTarget 为空），此时关闭会让 click 落空；外部点击交给 document click。
      this.addEventListener(
        'focusout',
        (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
        },
        options
      );
      this.details.addEventListener(
        'toggle',
        () => {
          if (!this.details.open) return;
          this.positionPanel();
          document.querySelectorAll('rewa-store-selector').forEach((other) => {
            if (other !== this) other.close();
          });
        },
        options
      );
      window.addEventListener('resize', () => this.positionPanel(), options);
      window.addEventListener('scroll', () => this.positionPanel(), { ...options, passive: true });
      this.addEventListener(
        'click',
        (event) => {
          const link = event.target.closest('[data-store-country]');
          if (!link || !this.contains(link) || event.defaultPrevented) return;
          // 修饰键及新标签页遵循原生链接行为；目的站由 URL 标记读取明确选择。
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const country = link.dataset.storeCountry;
          if (!VALID(country)) return;
          // 跨站导航已开始时忽略重复点击，避免移动端多次轻触重复发起请求。
          if (this.hasAttribute('aria-busy')) {
            event.preventDefault();
            return;
          }
          remember(country);
          if (country === this.dataset.country) {
            event.preventDefault();
            this.close(true);
            return;
          }
          this.setBusy(true);
        },
        options
      );
      // 从往返缓存返回时页面不会重新加载，需清除上次的切换中状态。
      window.addEventListener('pageshow', () => this.setBusy(false), options);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    setBusy(busy) {
      if (busy) this.setAttribute('aria-busy', 'true');
      else this.removeAttribute('aria-busy');
      const status = this.querySelector('.rewa-market__status');
      if (status) status.textContent = busy ? 'Switching store…' : '';
    }

    close(restoreFocus = false) {
      this.details.open = false;
      if (restoreFocus) this.trigger.focus();
    }

    positionPanel() {
      if (!this.details.open) return;
      const header = this.closest('.header-mobile');
      if (!header) return;
      const top = Math.max(8, header.getBoundingClientRect().bottom);
      this.style.setProperty('--market-panel-top', `${top}px`);
      const panel = this.querySelector('.rewa-market__panel');
      const offset = panel.getBoundingClientRect().top - top;
      this.style.setProperty('--market-panel-top', `${top - offset}px`);
      this.style.setProperty('--market-panel-max-height', `${Math.max(80, window.innerHeight - top - 16)}px`);
    }
  }

  if (!customElements.get('rewa-store-selector')) customElements.define('rewa-store-selector', StoreSelector);
})();
